import { render, staticRenderFns } from "./appendButton-editor.vue?vue&type=template&id=0980c721&scoped=true"
import script from "./appendButton-editor.vue?vue&type=script&lang=js"
export * from "./appendButton-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0980c721",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0980c721')) {
      api.createRecord('0980c721', component.options)
    } else {
      api.reload('0980c721', component.options)
    }
    module.hot.accept("./appendButton-editor.vue?vue&type=template&id=0980c721&scoped=true", function () {
      api.rerender('0980c721', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/appendButton-editor.vue"
export default component.exports